import React from 'react'
import { observer } from 'mobx-react'
import Icon from 'components/common/Icon'
import { withTranslation } from 'react-i18next'

const ErrorForm = ({ item, t }) => (
  <section>
    <ul className='unstyled nested-list'>
      <li className='error nonexpandable'>
        <nav><span className='name unselectable'>{item.error}</span></nav>
        <div className='button-row'>
          <button onClick={() => { item.error = null }}>
            <Icon id='fa-check' />
            {t('GLOBAL.OK')}
          </button>
        </div>
      </li>
    </ul>
  </section>
)

export default withTranslation()(observer(ErrorForm))
